import * as React from 'react';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { visuallyHidden } from '@mui/utils';
import {
    // Stack,

    CircularProgress,
    Typography,
} from '@mui/material';
// import { ReactComponent as TriangleIcon } from 'assets/images/Triangle.svg';
// import SvgIcon from '@mui/material/SvgIcon';

import CompletedModal, { inferCompletedModal } from './CompletedModal';
import MoveModal, { inferMoveModal } from './MoveModal';
import RowContent, { inferRowcontent } from './RowContent';
import TableRowVirtuoso, { inferTableRow } from './TableRow';
import TypographyLevel from 'shared/components/Typography';
import EmptyPlaceholder from 'shared/components/EmptyPlaceholder';
import { FlatPaginationComp } from 'shared/components/Pagination';

import { useMeasure, useTimeoutFn } from 'react-use';

import { AppPrimaryButton } from 'shared/components/AppComponents';

import BulkModal, { BulkData, inferBulkModal } from './BulkModal';
import { useSelector } from 'react-redux';
import DeletationModal, { inferDeletationModal } from './DeletationModal';
import DocumentModal, { inferDocumentModal } from './DocumentModal';
import { ManagePacketService } from 'services';
import { Utils } from 'shared/helpers';
import { useImperativeHandle } from 'react';
import { ListingMeta } from '../ManagePacketsPage';

export const TableMeta = React.createContext<TableMetaProps | null>(null);
export const HeaderContext = React.createContext<headerStyle | null>(null);

const headCells: readonly HeadCell[] = [
    {
        id: 'downloads',
        label: 'Downloads',
    },
    {
        id: 'packetStatus',
        label: 'Cross Check Status',
    },
    {
        id: 'SLADate',
        label: 'SLA',
    },
    {
        id: 'loanNumber',
        label: 'Application details',
    },
    {
        id: 'bin',
        label: 'Reference Number',
    },

    {
        id: 'actions',
        label: 'Actions',
    },
    {
        id: 'subactions',
        label: '',
    },
];

/**
 * Sorting functions for each properties.
 * @type {Object.<string, Function>}
 */
// const sortingFunctions: any = {
//     packetStatus: (a: any, b: any) => {
//         if (typeof a.packetStatus === 'string') {
//             return a.packetStatus.localeCompare(b.packetStatus);
//         }
//         return a.packetStatus - b.packetStatus;
//     },
//     SLADate: (a: any, b: any) => {
//         if (typeof a.SLADate === 'string') {
//             return a.SLADate.localeCompare(b.SLADate);
//         }
//         return a.SLADate - b.SLADate;
//     },
//     clientName: (a: any, b: any) => {
//         if (typeof a.clientName === 'string') {
//             return a.clientName.localeCompare(b.clientName);
//         }
//         return a.clientName - b.clientName;
//     },
//     bin: (a: any, b: any) => {
//         if (
//             typeof a.bin === 'string' &&
//             Number.isNaN(parseInt(a.bin, 10)) === true &&
//             typeof b.bin === 'string' &&
//             Number.isNaN(parseInt(b.bin, 10)) === true
//         ) {
//             return a.bin.localeCompare(b.bin);
//         }
//         const numberA = parseInt(a.bin, 10);
//         const numberB = parseInt(b.bin, 10);
//         return numberA - numberB;
//     },
//     loanNumber: (a: any, b: any) => {
//         if (typeof a.loanNumber === 'string') {
//             return a.loanNumber.localeCompare(b.loanNumber);
//         }
//         return a.loanNumber - b.loanNumber;
//     },
//     actions: (a: any, b: any) => {
//         if (typeof a.actions === 'string') {
//             return a.actions.localeCompare(b.actions);
//         }
//         return a.actions - b.actions;
//     },
// };

const FixedEnhancedTableHead = (
    props: EnhancedTableProps
): React.ReactElement => {
    const {
        order,
        orderBy,
        // onRequestSort,
        onBulkDownload,
        // sortOrder,
        // setSortOrder,
        // data,
        // setData,
    } = props;
    const { packetStatus } = useSelector(
        (state: any) => state.baseAppState.sidebarOptions.managePacket
    );
    const TableMetaProps = React.useContext(TableMeta);
    const headerTheme = React.useContext(HeaderContext);
    const [rowRef, { width }] = useMeasure<HTMLTableRowElement>();
    const isActiveBulked = React.useMemo(() => {
        if (packetStatus && Array.isArray(packetStatus)) {
            if (packetStatus.length === 0) {
                return true;
            }
            return packetStatus.some((e) => e === 'completed');
        }
        return false;
    }, [packetStatus]);

    const cellRef = React.useRef<HTMLTableCellElement[]>([]);
    const isDataBulkExist = React.useMemo(() => {
        if (
            Object.values(TableMetaProps?.bulkData ?? {}).some(
                (e) => e === true
            )
        ) {
            return true;
        }
        return false;
    }, [TableMetaProps?.bulkData]);

    React.useLayoutEffect(() => {
        const { current: arrayHeader } = cellRef;
        if (headerTheme) {
            arrayHeader.forEach((el, index) => {
                const layoutEl = el.getBoundingClientRect();
                switch (index) {
                    case 0:
                        headerTheme.packetStatus = layoutEl.width;
                        break;
                    case 1:
                        headerTheme.bin = layoutEl.width;

                        break;
                    case 2:
                        headerTheme.loan = layoutEl.width;

                        break;
                    case 3:
                        headerTheme.SLA = layoutEl.width;

                        break;
                    case 4:
                        headerTheme.actions = layoutEl.width;
                        break;
                    case 5:
                        headerTheme.subactions = layoutEl.width;
                        break;
                    default:
                        break;
                }
            });
        }
    }, [width]);

    /**
     * Sorts data packet based on the each property.
     * @param {string} property - The property to sort by each property.
     */
    // const sortingData = (property: string): void => {
    //     try {
    //         const sortedData = [...data];

    //         sortedData.sort((a, b) =>
    //             sortOrder === 'asc'
    //                 ? sortingFunctions[property](a, b)
    //                 : sortingFunctions[property](b, a)
    //         );

    //         setData(sortedData);
    //         setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    //     } catch (e) {
    //         // Intentionally left empty (no action required here)
    //         // eslint-disable-next-line no-empty
    //     }
    // };

    // const actionOnTableSortToSorting =
    //     (property: keyData) => (event: React.MouseEvent<unknown>) => {
    //         // sortingData(property);
    //         if (property === 'actions') {
    //             event.preventDefault();
    //         } else {
    //             onRequestSort(event, property);
    //         }
    //     };
    // const renderDropdownIndicator = (
    //     _props: DropDownProps
    // ): React.ReactElement => {
    //     const arrowUpSelector =
    //         order === 'asc' && orderBy === _props.headCellId
    //             ? 'selected'
    //             : 'not-selected';
    //     const arrowDownSelector =
    //         order === 'desc' && orderBy === _props.headCellId
    //             ? 'selected'
    //             : 'not-selected';
    //     return (
    //         <Stack
    //             direction="column"
    //             className={`table-history-indicator-sort ${_props.className}`}
    //         >
    //             <SvgIcon
    //                 component={TriangleIcon}
    //                 inheritViewBox
    //                 className={`table-history-indicator-up ${arrowUpSelector}`}
    //                 fontSize="inherit"
    //             />
    //             <SvgIcon
    //                 component={TriangleIcon}
    //                 inheritViewBox
    //                 className={`table-history-indicator-down ${arrowDownSelector}`}
    //                 fontSize="inherit"
    //             />
    //         </Stack>
    //     );
    // };

    return (
        <TableRow ref={rowRef}>
            {headCells.map((headCell, index) => (
                <TableCell
                    ref={(ref) => {
                        if (ref) {
                            cellRef.current[index] =
                                ref as HTMLTableCellElement;
                        }
                    }}
                    key={`${headCell.id} - ${index}`}
                    align={headCell.id === 'actions' ? 'right' : 'left'}
                    sortDirection={orderBy === headCell.id ? order : false}
                >
                    <span
                        className={
                            headCell.id === 'actions' ? 'revert-cell' : ''
                        }
                    >
                        {headCell.id === 'downloads' &&
                        isDataBulkExist &&
                        isActiveBulked ? (
                            <AppPrimaryButton
                                title="Bulk Download"
                                loadingSize={22}
                                onClick={onBulkDownload}
                                className="btn-small bulk-download download"
                                aria-haspopup="dialog"
                            />
                        ) : (
                            <>
                                <TypographyLevel
                                    variant="fifth"
                                    className="head-label"
                                >
                                    {headCell.label}
                                </TypographyLevel>
                                {orderBy === headCell.id ? (
                                    <Box component="span" sx={visuallyHidden}>
                                        {order === 'desc'
                                            ? 'sorted descending'
                                            : 'sorted ascending'}
                                    </Box>
                                ) : null}
                            </>
                        )}
                    </span>
                </TableCell>
            ))}
        </TableRow>
    );
};

const VirtualizedTable: React.FC<VirtualizedTable> = React.forwardRef(
    (
        {
            data: defaultData,
            dataRow,
            page,
            innerSidebar,
            setPage,
            setSortingBasedOnTable,
            isLoading,
            setIsLoading,
            rowsPerPage,
            setRowsPerPage,
        },
        ref
    ) => {
        const documentModalRef = React.useRef<inferDocumentModal | null>(null);
        const listingMetaProps = React.useContext(ListingMeta);
        const [order, setOrder] = React.useState<'asc' | 'desc'>('desc');
        const [orderBy, setOrderBy] = React.useState<keyData>('bin');
        const arrayRowContentRef = React.useRef<Array<inferRowcontent>>([]);
        const arrayTableRowRef = React.useRef<Array<inferTableRow>>([]);
        const completedModalRef = React.useRef<inferCompletedModal | null>(
            null
        );
        const moveModalRef = React.useRef<inferMoveModal | null>(null);
        const bulkModalRef = React.useRef<inferBulkModal | null>(null);
        const deletationModalRef = React.useRef<inferDeletationModal | null>(
            null
        );
        const [visibleModal, setVisibleModal] = React.useState<Data | null>(
            null
        );

        const [data, setData] = React.useState<Data[]>([]);
        const [savedPacketId, setPacketId] = React.useState<string | null>(
            null
        );
        const [tableRef, { width }] = useMeasure<HTMLTableElement>();
        const innerPaginationComp = React.useRef<HTMLDivElement>(null);
        const [toggleData, setToggleData] = React.useState<ToggleData>({});
        const [stickyData, setStickyData] = React.useState<ToggleData>({});
        const [bulkData, setBulkData] = React.useState<ToggleData>({});
        const [savedBulkData, setSavedBulkData] = React.useState<BulkData>({});

        const handleRefreshData = React.useCallback(() => {
            if (innerSidebar?.current) {
                innerSidebar.current.getRefreshData();
            }
        }, [innerSidebar]);
        const [isReady, cancel, reset] = useTimeoutFn(handleRefreshData, 1000);

        React.useLayoutEffect(() => {
            data.forEach((el, index) => {
                const keysSavedBulk = Object.keys(savedBulkData);

                if (
                    keysSavedBulk.includes(el.actions.uuid) &&
                    arrayRowContentRef.current[index] &&
                    (el.actions.type === 'Completed') === false
                ) {
                    if (data) {
                        const dataBulk = data[index];

                        setSavedBulkData((prev) => ({
                            ...prev,
                            [dataBulk.actions.uuid]: dataBulk,
                        }));
                    }

                    arrayRowContentRef.current[index].setBulk(false);
                }
            });
        }, [listingMetaProps?.globalRefreshing]);
        React.useEffect(() => {
            if (isReady() === false) {
                cancel();
            }
        }, []);
        React.useLayoutEffect(() => {
            setData(defaultData);
            const arrayOfHighlightedData = Array.from(defaultData as Data[])
                .filter((el) => typeof el.highlighted === 'boolean')
                .map((el) => ({ [el.actions.uuid]: el.highlighted }));
            setStickyData(Object.assign({}, ...arrayOfHighlightedData));

            if (innerSidebar) {
                const sortByKey = innerSidebar.current?.getValueSortBy();
                switch (sortByKey) {
                    case 'statusAscending':
                        setOrder('asc');
                        setOrderBy('packetStatus');
                        break;
                    case 'statusDescending':
                        setOrder('desc');
                        setOrderBy('packetStatus');
                        break;

                    case 'daysLeftToSLA':
                        setOrder('asc');
                        setOrderBy('SLADate');
                        break;
                    case 'desDaysLeftToSLA':
                        setOrder('desc');
                        setOrderBy('SLADate');
                        break;
                    case 'clientAscending':
                        setOrder('asc');
                        setOrderBy('clientName');
                        break;
                    case 'clientDescending':
                        setOrder('desc');
                        setOrderBy('clientName');
                        break;
                    case 'binAscending':
                        setOrder('asc');
                        setOrderBy('bin');
                        break;
                    case 'binDescending':
                        setOrder('desc');
                        setOrderBy('bin');
                        break;
                    case 'loanAscending':
                        setOrder('asc');
                        setOrderBy('loanNumber');
                        break;
                    case 'loanDescending':
                        setOrder('desc');
                        setOrderBy('loanNumber');
                        break;

                    default:
                        setOrder('asc');
                        setOrderBy('actions');
                        break;
                }
            }
        }, [defaultData]);
        // use local change
        const [locker, setLocker] = React.useState<boolean[]>([]);
        React.useEffect(() => {
            setLocker(Array.from({ length: data.length }).map(() => false));
        }, [data.length]);
        const initialTableMeta = React.useMemo(
            () => ({
                locker,
                setLocker,
                data: Array.from(data as Data[]).map((i) => i.isOpen),
                arrayUUID: Array.from(data as Data[]).map(
                    (i) => i.actions.uuid
                ),
                toggleData,
                stickyData,
                bulkData,
                setToggleData,
                setStickyData,
                setBulkData,
            }),
            [bulkData, data, locker, stickyData, toggleData]
        );

        const useSelectedButtonCallback = React.useCallback(
            (event: React.MouseEvent<HTMLButtonElement>, row: Data | null) => {
                if (row?.actions.type === 'Verified') {
                    if (row.reportReviewed === false) {
                        setPacketId(row.actions.uuid);

                        documentModalRef.current?.setOpen();
                    } else {
                        moveModalRef.current?.setData(row);
                        moveModalRef.current?.setOpen();
                    }
                } else if (row != null) {
                    completedModalRef.current?.setData(row);
                    completedModalRef.current?.setOpen();
                }
            },
            [completedModalRef, moveModalRef]
        );
        const useHighlightButtonCallback = React.useCallback(
            (
                event: React.MouseEvent<HTMLDivElement>,
                value: boolean,
                index: number
            ) => {
                if (arrayTableRowRef.current[index]) {
                    cancel();
                    reset();
                    arrayTableRowRef.current[index].setSticky(value);
                }
            },
            [cancel, reset]
        );

        const useBulkCheckboxCallback = React.useCallback(
            (
                event: React.MouseEvent<HTMLDivElement>,
                value: boolean,
                index: number
            ) => {
                if (arrayRowContentRef.current[index]) {
                    if (data) {
                        if (value) {
                            const dataBulk = data[index];

                            setSavedBulkData((prev) => ({
                                ...prev,
                                [dataBulk.actions.uuid]: dataBulk,
                            }));
                        } else {
                            const dataBulk = data[index];
                            setSavedBulkData((prev) => {
                                const filteredPrev = prev;
                                delete filteredPrev[dataBulk.actions.uuid];
                                return {
                                    ...filteredPrev,
                                };
                            });
                        }
                    }

                    arrayRowContentRef.current[index].setBulk(value);
                }
            },
            [data]
        );
        const handleSavingModal = React.useCallback(
            (packetId: string | undefined | null) => {
                if (typeof packetId === 'string') {
                    ManagePacketService.patchOperatorAction({
                        open: false,
                        packetId,
                    })
                        .then(() => {
                            if (typeof handleRefreshData === 'function') {
                                handleRefreshData();
                            }
                            setPacketId(null);
                        })
                        .catch((error) => {
                            if (typeof handleRefreshData === 'function') {
                                handleRefreshData();
                            }
                            setPacketId(null);
                            Utils.handleErrorResponse(error);
                        });
                } else {
                    if (typeof handleRefreshData === 'function') {
                        handleRefreshData();
                    }
                    setPacketId(null);
                }
            },
            [handleRefreshData]
        );
        const useModalClosingCallback = React.useCallback(
            (uuid: null | string | string[]) => {
                if (typeof uuid === 'string') {
                    ManagePacketService.patchOperatorAction({
                        open: false,
                        packetId: uuid,
                    }).catch(Utils.handleErrorResponse);
                } else if (
                    typeof uuid === 'object' &&
                    Array.isArray(uuid) &&
                    uuid.every((t) => typeof t === 'string')
                ) {
                    const prefetchPatchOperator: Promise<any>[] = Array.from(
                        uuid
                    ).map(
                        (el) =>
                            new Promise((resolve, reject) => {
                                ManagePacketService.patchOperatorAction({
                                    open: false,
                                    packetId: el,
                                })
                                    .then(resolve)
                                    .catch(reject);
                            })
                    );
                    Promise.all(prefetchPatchOperator).catch(
                        Utils.handleErrorResponse
                    );
                }
                setVisibleModal(null);
            },
            []
        );
        const useMoveToCM9 = React.useCallback((uuid: string) => {
            setData((prev) =>
                Array.from(prev).map((o) => {
                    if (o.actions.uuid === uuid) {
                        return {
                            ...o,
                            packetStatus: 'Completed',
                            actions: {
                                ...o.actions,
                                type: 'Completed',
                            },
                        };
                    }
                    return o;
                })
            );
        }, []);
        const useSelectedCallback = React.useCallback(
            (
                event: React.MouseEvent<HTMLDivElement, MouseEvent>,
                indices: string,
                index: number
            ) => {
                if (arrayRowContentRef.current[index].isOpen() === false) {
                    arrayRowContentRef.current[index].setOpen();
                } else {
                    arrayRowContentRef.current[index].setClose();
                }

                if (arrayTableRowRef.current[index].isOpen() === false) {
                    arrayTableRowRef.current[index].setOpen();
                } else {
                    arrayTableRowRef.current[index].setClose();
                }
            },
            []
        );

        const actionOnTableHeadToRequestSort = React.useCallback(
            (event: React.MouseEvent<unknown>, property: keyData): void => {
                // const isAsc = orderBy === property && order === 'asc';
                const isAsc = orderBy === property && order === 'asc';
                setOrder(isAsc ? 'desc' : 'asc');
                setOrderBy(property);
                if (typeof setSortingBasedOnTable === 'function') {
                    setSortingBasedOnTable(isAsc ? 'desc' : 'asc', property);
                }
            },
            [order, orderBy, setSortingBasedOnTable]
        );

        /**
         * Handles pagination page change.
         * @param {object} event - The event object.
         * @param {number} newPage - The new page number.
         * @returns {void}
         */
        const onChangePagination = React.useCallback(
            (event: any, newPage: any): void => {
                setIsLoading(true);
                setPage(newPage - 1);
            },
            [setIsLoading, setPage]
        );

        const initialHeaderStyle = React.useMemo(
            () => ({
                download: 0,
                packetStatus: 0,
                SLA: 0,
                client: 0,
                bin: 0,
                loan: 0,
                actions: 0,
                subactions: 0,
            }),
            []
        );
        React.useEffect(() => {
            window.addEventListener('error', (e) => {
                if (
                    e.message ===
                    'ResizeObserver loop completed with undelivered notifications.'
                ) {
                    const resizeObserverErrDiv = document.getElementById(
                        'webpack-dev-server-client-overlay-div'
                    );
                    const resizeObserverErr = document.getElementById(
                        'webpack-dev-server-client-overlay'
                    );
                    if (resizeObserverErr) {
                        resizeObserverErr.setAttribute(
                            'style',
                            'display: none'
                        );
                    }
                    if (resizeObserverErrDiv) {
                        resizeObserverErrDiv.setAttribute(
                            'style',
                            'display: none'
                        );
                    }
                }
            });
        }, []);

        React.useLayoutEffect(() => {
            const { current: element } = innerPaginationComp;
            if (element) {
                element.style.width = `${width}px`;
            }
        }, [width, data.length]);

        const handleBulkModalOpen = React.useCallback(() => {
            const prefetchPatchOperator: Promise<any>[] = Array.from(
                Object.keys(savedBulkData ?? {})
            ).map(
                (el) =>
                    new Promise((resolve, reject) => {
                        ManagePacketService.patchOperatorAction({
                            open: true,
                            packetId: el,
                        })
                            .then(resolve)
                            .catch(reject);
                    })
            );

            Promise.all(prefetchPatchOperator)
                .then(() => {
                    bulkModalRef.current?.setOpen();
                })
                .catch(Utils.handleErrorResponse);
        }, [savedBulkData]);
        const handleOnFinishRevalidate = React.useCallback(() => {
            cancel();
            reset();
        }, [cancel, reset]);

        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        const handleChangeRowsPerPage = React.useCallback(
            (
                event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
            ) => {
                setRowsPerPage(parseInt(event.target.value, 10));
                setPage(0);
                setIsLoading(true);
            },
            [setIsLoading, setPage, setRowsPerPage]
        );
        const handleDeletationModal = React.useCallback((packetId: string) => {
            setPacketId(packetId);
            deletationModalRef.current?.setOpen();
        }, []);

        const handleDeletetationModal = React.useCallback(() => {
            if (typeof handleRefreshData === 'function') {
                handleRefreshData();
            }
            setPacketId(null);
        }, [handleRefreshData]);

        const handleCloseDeletetationModal = React.useCallback(() => {
            setPacketId(null);
        }, []);

        React.useLayoutEffect(() => {
            listingMetaProps?.setSidebarStaticWidth(width);
        }, [width]);

        useImperativeHandle(
            ref,
            () => ({
                getTableWidth: () => width,
            }),
            [width]
        );

        return (
            <Box className="container-packets-table">
                <HeaderContext.Provider value={initialHeaderStyle}>
                    <Paper elevation={0} className="manage-packets-table">
                        <TableContainer className="manage-packet-table-container">
                            <Typography variant="h3">Cross Checks</Typography>
                            <TableMeta.Provider value={initialTableMeta}>
                                <Table
                                    ref={tableRef}
                                    aria-labelledby="tableTitle"
                                    size="medium"
                                >
                                    <TableHead className="manage-packets-table-head">
                                        <FixedEnhancedTableHead
                                            order={order}
                                            orderBy={orderBy}
                                            onRequestSort={
                                                actionOnTableHeadToRequestSort
                                            }
                                            onBulkDownload={handleBulkModalOpen}
                                            // sortOrder={sortOrder}
                                            // setSortOrder={setSortOrder}
                                            // data={data}
                                            // setData={setData}
                                        />
                                    </TableHead>
                                    {isLoading && (
                                        <TableBody className="manage-client-relative">
                                            <Box
                                                minHeight={400}
                                                position="relative"
                                            >
                                                <Box className="align-loader-table">
                                                    <CircularProgress
                                                        className="mr-2 margin-loader"
                                                        size={54}
                                                        color="inherit"
                                                        title="progress loading"
                                                    />
                                                </Box>
                                            </Box>
                                        </TableBody>
                                    )}
                                    {!isLoading && data.length < 1 && (
                                        <TableBody className="manage-client-relative">
                                            <Box className="align-loader-placeholder">
                                                <EmptyPlaceholder
                                                    message={
                                                        listingMetaProps?.isNetworkError
                                                            ? 'No internet connection, Please try again!'
                                                            : 'There are no packet records yet'
                                                    }
                                                />
                                            </Box>
                                        </TableBody>
                                    )}

                                    {!isLoading && data.length > 0 && (
                                        <TableBody className="manage-packets-table-body">
                                            {data.map(
                                                (
                                                    element: any,
                                                    index: number
                                                ) => (
                                                    <TableRowVirtuoso
                                                        ref={(ref) => {
                                                            if (
                                                                ref &&
                                                                ref !== null
                                                            )
                                                                arrayTableRowRef.current[
                                                                    index
                                                                ] = ref;
                                                        }}
                                                        onFinishRevalidate={
                                                            handleOnFinishRevalidate
                                                        }
                                                        key={
                                                            element.actions.uuid
                                                        }
                                                        item={element}
                                                        data-index={
                                                            element.actions.uuid
                                                        }
                                                        data-item-index={index}
                                                        data-known-size={index}
                                                        data-item-group-index={
                                                            index
                                                        }
                                                    >
                                                        <RowContent
                                                            ref={(ref) => {
                                                                if (
                                                                    ref !== null
                                                                )
                                                                    arrayRowContentRef.current[
                                                                        index
                                                                    ] = ref;
                                                            }}
                                                            _index={index}
                                                            uuid={
                                                                element.actions
                                                                    .uuid
                                                            }
                                                            row={element}
                                                            page={0}
                                                            setChildOpen={
                                                                useSelectedCallback
                                                            }
                                                            setModalOpen={
                                                                useSelectedButtonCallback
                                                            }
                                                            setHighlightToggle={
                                                                useHighlightButtonCallback
                                                            }
                                                            setBulkToggle={
                                                                useBulkCheckboxCallback
                                                            }
                                                            triggerDeletationModal={
                                                                handleDeletationModal
                                                            }
                                                        />
                                                    </TableRowVirtuoso>
                                                )
                                            )}
                                        </TableBody>
                                    )}
                                </Table>

                                <FlatPaginationComp
                                    hidden={
                                        (!isLoading && data.length >= 1) ===
                                        false
                                    }
                                    containerClassName="managepacket"
                                    className="table-manage-packet-pagination"
                                    innerRef={innerPaginationComp}
                                    data={dataRow}
                                    page={page}
                                    count={Math.ceil(dataRow / rowsPerPage)}
                                    onPageChange={onChangePagination}
                                    rowsPerPage={rowsPerPage}
                                    onRowsPerPageChange={
                                        handleChangeRowsPerPage
                                    }
                                    onChange={onChangePagination}
                                    popupPrevNext
                                />
                            </TableMeta.Provider>
                        </TableContainer>
                    </Paper>
                </HeaderContext.Provider>
                <DocumentModal
                    packetId={savedPacketId}
                    ref={documentModalRef}
                    callbackSavingModal={handleSavingModal}
                    callbackClosingModal={handleSavingModal}
                />
                <CompletedModal
                    ref={completedModalRef}
                    callbackClosingModal={useModalClosingCallback}
                    packetData={visibleModal}
                />
                <MoveModal
                    ref={moveModalRef}
                    callbackClosingModal={useModalClosingCallback}
                    packetData={visibleModal}
                    onMoveCM9={useMoveToCM9}
                />
                <BulkModal
                    ref={bulkModalRef}
                    callbackClosingModal={useModalClosingCallback}
                    bulkData={savedBulkData}
                />
                <DeletationModal
                    ref={deletationModalRef}
                    callbackDeletationModal={handleDeletetationModal}
                    callbackClosingModal={handleCloseDeletetationModal}
                    packetId={savedPacketId}
                />
            </Box>
        );
    }
);

export default VirtualizedTable;
